export const BrandListAssociation = {
  properties: {
    Id: {
      // Id property is injected into the schema to trick bulkify.js into thinking it is a root entity.
      'bulk-upload-header': 'Id',
    },
    SharedEntityId: {
      'bulk-upload-header': 'Id',
    },
    EntityId: {
      'bulk-upload-header': 'Parent ID',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    IsExclusion: {
      'bulk-upload-header': 'IsExclusion',
    },
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Brand List Association',
    },
  },
};
